module.exports = __webpack_public_path__ + "assets/webgl/art_080_L0.489943a2.jpg";